var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 18.411V11.7534V11.7525C21.6 11.1119 21.6 10.7915 21.5221 10.4932C21.453 10.2288 21.3392 9.97807 21.1857 9.75196C21.0125 9.4968 20.7715 9.28574 20.2889 8.86351L14.5289 3.8235C13.633 3.03956 13.185 2.64764 12.6809 2.49855C12.2366 2.36718 11.7634 2.36718 11.3191 2.49855C10.8153 2.64756 10.3677 3.03914 9.47279 3.82222L9.47132 3.8235L3.71132 8.86351L3.71017 8.86452C3.22838 9.28608 2.98732 9.49701 2.81425 9.75196C2.66076 9.97807 2.54705 10.2288 2.47796 10.4932C2.39999 10.7916 2.39999 11.1122 2.39999 11.7534V18.411C2.39999 19.5292 2.39999 20.0882 2.58268 20.5293C2.82627 21.1174 3.29376 21.5846 3.88183 21.8282C4.32288 22.0109 4.88201 22.0109 6.00027 22.0109C7.11853 22.0109 7.67738 22.0109 8.11843 21.8282C8.7065 21.5846 9.1736 21.1174 9.41718 20.5293C9.59987 20.0882 9.59999 19.5291 9.59999 18.4109V17.2109C9.59999 15.8854 10.6745 14.8109 12 14.8109C13.3255 14.8109 14.4 15.8854 14.4 17.2109V18.4109C14.4 19.5291 14.4 20.0882 14.5827 20.5293C14.8263 21.1174 15.2938 21.5846 15.8818 21.8282C16.3229 22.0109 16.882 22.0109 18.0003 22.0109C19.1185 22.0109 19.6774 22.0109 20.1184 21.8282C20.7065 21.5846 21.1736 21.1174 21.4172 20.5293C21.5999 20.0882 21.6 19.5292 21.6 18.411Z",
    stroke: "current",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ee277415f1ee41f52a1a85f24d11673d.svg";
export { ForwardRef as ReactComponent };